import { fetchScannerFilterTags } from "@/Groups/Scanner/private/api/filtersData";
import { fetchCustomTags } from "@/Groups/Scanner/private/api/customTagsData";

const state = () => ({
  categories: [],
  customTags: [],
  isLoadingData: false,
  isReady: false,
  isReadyCustom: false,
  top: 100,
  tagId: null,
  customTagId: null,
  isBriefcase: false,
});

const actions = {
  async initCategories({ commit }){
    try{
      commit('SET_LOADING_FLAG', true);
      const data = await fetchScannerFilterTags();
      commit('SET_READY_FLAG', true);
      commit('SET_DATA', data);
      return data;
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async initCustomTags({ state, commit }){
    try{
      const data = await fetchCustomTags();
      commit('SET_CUSTOM_READY_FLAG', true);
      commit('SET_CUSTOM_DATA', data);
      return data;
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async activeBriefcaseFilter({ commit }){
    commit('SET_TAG_ID', null);
    commit('SET_TOP_VALUE', 300);
    commit('SET_BRIEFCASE_FLAG', true);
    commit('SET_CUSTOM_TAG_ID', null);
  },

  async activeTopFilter({ commit }, { top }){
    commit('SET_TOP_VALUE', top);
    commit('SET_TAG_ID', null);
    commit('SET_BRIEFCASE_FLAG', null);
    commit('SET_CUSTOM_TAG_ID', null);
  },

  async activeCategoryFilter({ commit }, { tagId }){
    commit('SET_TOP_VALUE', 300);
    commit('SET_TAG_ID', tagId);
    commit('SET_BRIEFCASE_FLAG', null);
    commit('SET_CUSTOM_TAG_ID', null);
  },

  async activeCustomTag({ state, commit }, { tagId }){
    commit('SET_TAG_ID', null);
    commit('SET_TOP_VALUE', 300);
    commit('SET_BRIEFCASE_FLAG', false);
    commit('SET_CUSTOM_TAG_ID', tagId);
  },

  resetFilters({ commit }) {
    commit('SET_DATA', []);
    commit('SET_CUSTOM_DATA', []);
    commit('SET_READY_FLAG', false);
    commit('SET_CUSTOM_READY_FLAG', false);
    commit('SET_TOP_VALUE', 100);
    commit('SET_TAG_ID', null);
    commit('SET_CUSTOM_TAG_ID', null);
    commit('SET_BRIEFCASE_FLAG', false);
    commit('SET_LOADING_FLAG', false);
  }
};

const mutations = {
  SET_DATA(state, data){ state.categories = data; },

  SET_CUSTOM_DATA(state, data){ state.customTags = data; },

  SET_READY_FLAG(state, status = true){ state.isReady = status; },

  SET_CUSTOM_READY_FLAG(state){ state.isReadyCustom = true; },

  SET_LOADING_FLAG(state, status){ state.isLoading = status; },

  SET_TOP_VALUE(state, value){ state.top = value; },

  SET_TAG_ID(state, id){ state.tagId = id; },

  SET_CUSTOM_TAG_ID(state, id){ state.customTagId = id; },

  SET_BRIEFCASE_FLAG(state, status){ state.isBriefcase = status; }
};

const getters = {
  //Получить список категорий
  getCategories: (state) => state.categories,
  //Получить список кастомных тегов
  getCustomTags: (state) => state.customTags,
  //Готов ли список к отображению
  isReadyCategories: (state) => state.isReady,
  //Готов ли список к отображению
  isReadyCustomTags: (state) => state.isReadyCustom,
  //Получить значение Top
  getTop: (state) => state.top,
  //Получить id Активного фильтра
  getTagId: (state) => state.tagId,
  //Получить id Активного кастомного тега
  getCustomTagId: (state) => state.customTagId,
  //Получить флаг, активен ли фильтр по портфелю
  getIsBriefcase: (state) => state.isBriefcase,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
